import { useParams } from 'react-router';
import { DisplayCloudType } from 'packages/cosell/src/types/enums';
import CloudPage from 'packages/cosell/src/components/CloudPage';
import useMsftReferral from '../hooks/useMsftReferral';
import { Loader } from '@tackle-io/platform-ui';
import { useTheme } from 'vendor/material';
import Tags from './Tags';
import CustomerDetailsSection from './CustomerDetailsSection';
import DealDetailsSection from './DealDetailsSection';
import SolutionsSection from './SolutionSection/SolutionsSection';
import TeamMembersSection from './TeamMembersSection/TeamMembersSection';

const ViewReferralPage = () => {
  const theme = useTheme();
  const { tackleId } = useParams<{ tackleId: string }>();
  const { data: referral, isLoading } = useMsftReferral({ tackleId });

  if (isLoading) {
    return <Loader />;
  }

  if (!referral) {
    return (
      <CloudPage
        titleProps={{
          cloud: DisplayCloudType.MICROSOFT,
          title: 'Referral not found',
        }}
      >
        <CloudPage.Content>
          <p>Referral with tackleId: {tackleId} not found</p>
        </CloudPage.Content>
      </CloudPage>
    );
  }

  return (
    <CloudPage
      titleProps={{
        cloud: DisplayCloudType.MICROSOFT,
        title: referral.customerProfile?.name,
        subtitle: referral?.name,
      }}
    >
      <CloudPage.Content style={{ marginBottom: theme.spacing(4) }}>
        <Tags tackleId={tackleId} />
      </CloudPage.Content>

      <CloudPage.Content
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
        }}
      >
        <CustomerDetailsSection tackleId={tackleId} />
        <DealDetailsSection tackleId={tackleId} />
        <SolutionsSection tackleId={tackleId} />
        <TeamMembersSection tackleId={tackleId} />
      </CloudPage.Content>
    </CloudPage>
  );
};

export default ViewReferralPage;
